import React from 'react';
import format from 'date-fns/format';
import isNil from 'lodash/isNil';

import {isTrashDate} from '~/misc/dates';
import {getDistance} from '~/misc/geo';

import css from './index.css';

const dataQa = (name) => `qa-search-result-details-${name}`;

const formatDate = (date) => date ? {
  day: format(date, 'MMM D'),
  time: !isTrashDate(date) && format(date, 'h:mm A'),
} : null;

const diffQueryLocation = (query, queryDeadhead, queryKey, response, responseKey) => {
  if (isNil(queryDeadhead)) {
    return null;
  }

  const queryName = query[`${queryKey}_name`];

  return {
    name: queryName,
    distance: getDistance({
      lat: query[`${queryKey}_lat`],
      lng: query[`${queryKey}_lng`],
    }, response[`${responseKey}_location`]),
  };
};

const Desc = ({children}) => <span className={css.desc}>{children}</span>;
const Header = ({text}) => (
  <div className={css.header}>
    <span className={css.headerText}>{text}</span>
    <span className={css.headerDecor} />
  </div>
);

const Attr = ({name, children}) => (
  <section className={css.attr}>
    <Desc>{name}</Desc>{' '}
    {children}
  </section>
);

export {dataQa, Header, Attr, Desc, formatDate, diffQueryLocation};



// WEBPACK FOOTER //
// ./src/components/search/results/LoadCard/helpers.js